module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/images/link.363c4bdc.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/images/link.png
// module id = 1317
// module chunks = 16